import { RouteObject } from "react-router-dom";
import ProtectedRoutes from "../../../core/navigation/protectedRoutes";
import { MacroToolRoutesConfig } from "./config";
import MacroToolPage from "../routes/MacroToolPage/MacroToolPage";
import CreateScenarioPage from "../routes/MacroToolScenarioPage/MacroToolScenarioPage";
import { RootPage } from "components/sections";
import MacroAdjustmentsPage from "../routes/MacroAdjustmentsPage/MacroAdjustmentsPage";
import MacroAdjustmentWizard from "../routes/MacroAdjustmentWizard/MacroAdjustmentWizard";
export const MacroToolRoutes: RouteObject = {
  path: MacroToolRoutesConfig.countryLevelAnalytics,
  element: (
    <ProtectedRoutes>
      <RootPage />
    </ProtectedRoutes>
  ),
  children: [
    { index: true, element: <MacroToolPage /> },
    {
      path: MacroToolRoutesConfig.scenarioPage,
      element: <CreateScenarioPage />,
    },
    {
      path: MacroToolRoutesConfig.adjustmentsPage,
      element: (
        <ProtectedRoutes>
          <MacroAdjustmentsPage />
        </ProtectedRoutes>
      ),
    },
    {
      path: MacroToolRoutesConfig.createAdjustment,
      element: (
        <ProtectedRoutes>
          <MacroAdjustmentWizard />
        </ProtectedRoutes>
      ),
    },
    {
      path: MacroToolRoutesConfig.editAdjustment,
      element: (
        <ProtectedRoutes>
          <MacroAdjustmentWizard />
        </ProtectedRoutes>
      ),
    },
  ],
};
